import React from 'react';
import { Card } from "react-bootstrap";
import face_noemi_friedman from "../../assets/img/face_noemi_friedman.png";
import face_andras_benczur from "../../assets/img/face_andras_benczur.png";
import ShowMoreText from "react-show-more-text";
import proj_distr_learning from "../../assets/img/proj_distr_learning.png";

const N_Friedman_and_A_Benczur_distr_learning = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_distr_learning} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_noemi_friedman}
              alt="Model Calibration, Distribution Learning, and Uncertainty Quantification"
            />{" "}
            <p className="text7">Noémi Friedman</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_andras_benczur}
              alt="Model Calibration, Distribution Learning, and Uncertainty Quantification"
            />{" "}
            <p className="text7">András Benczúr</p>
            <br />
            <p className="text8">
              Head of Research Laboratory{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">HUN-REN SZTAKI AI Laboratory</p>
            </div>
            <div>
            When modeling engineering and physical systems (e.g., finite element simulations), 
            we often face the challenge that model parameters—such as material properties, boundary 
            conditions, loads, or degradation processes—are not known precisely and must instead be 
            inferred from measurement data or observations. In such cases, the goal is not merely to 
            determine a single "best" parameter value (calibration), but also to characterize the 
            uncertainty surrounding the parameters: what distribution of possible parameter values 
            is consistent with the available data, and how does this uncertainty propagate to the 
            model predictions (uncertainty quantification, UQ)?
            <br />
            <br />
            The main focus of the project is to improve physics-based models and develop physics-informed 
            models (such as physics-informed neural networks, PINNs, or hybrid physics- and data-driven 
            surrogate models) in a way that they provide not only point predictions but also estimates of 
            predictive uncertainty, enabling uncertainty-aware modeling. The student will become familiar 
            with fundamental statistical and Bayesian approaches to model calibration and uncertainty 
            quantification, including Bayesian inverse problems, Markov chain Monte Carlo, and variational 
            inference. The project will also explore modern machine learning-based approaches that make 
            these tasks tractable for high-dimensional or computationally expensive models, such as 
            distribution-learning methods and generative models for representing posterior distributions 
            over model parameters.
            <br />
            <br />
            Depending on the student's interests, the methodology can be applied to a range of concrete domains, 
            for example:
            <ul>
                <li>
                  <b>Structural health monitoring:</b> estimating the condition of bridges and buildings and detecting 
                  damage based on sensor data, while explicitly accounting for uncertainty;
                </li>
                <li>
                  <b>Semiconductor manufacturing:</b> calibrating physics-based models of manufacturing processes 
                  and quantifying uncertainty in process parameters for yield and quality prediction;
                </li>
                <li>
                  <b>Fracture mechanics:</b> calibrating crack propagation models while accounting for parameter and 
                  predictive uncertainty;
                </li>
                <li>
                  <b>Digital twins for building energy consumption:</b> calibrating building-physics and thermal models 
                  based on measurement data and providing reliable energy consumption predictions with uncertainty intervals.
                </li>
            </ul>
            <br />
            The specific application area and methodological emphasis can be jointly determined with the student. 
            If multiple students are interested in the topic, the project can naturally be divided into subprojects, 
            either by methodological direction (e.g., classical Bayesian calibration / distribution-learning approaches 
            for posterior approximation / PINN-based modeling) or by application area (selecting one of the four domains 
            above).
            <br />
            <br />
            <b>Required Skills and Prerequisites</b>
            <ul>
              <li>
                English proficiency
              </li>
              <li>
                Python programming
              </li>
              <li>
                <b>Advantageous, but not required:</b> knowledge of probability and statistics, experience with finite 
                element simulations, familiarity with physics-informed neural networks (PINNs), and basic knowledge 
                of machine learning / deep learning (e.g., PyTorch)
              </li>
            </ul>
            Related literature:{" "}
            <ul>
                <li>
                <a href="https://www.taylorfrancis.com/chapters/edit/10.1201/b22018-10/worked-example-surrogate-based-bayesian-parameter-field-identification-methods-no%C3%A9mi-friedman-claudia-zoccarato-elmar-zander-hermann-matthies">
                Friedman, N., Zoccarato, C., Zander, E., & Matthies, H. G. (2021). 
                A worked-out example of surrogate-based Bayesian parameter and field 
                identification methods. In Bayesian inverse problems (pp. 155–203). CRC Press.</a>
                </li>
                <li>
                <a href="https://openreview.net/forum?id=m09Wan0Okd">
                Kelen, D. M., Jung, Á., & Benczur, A. A. (2025). 
                Quantification vs. Reduction: On Evaluating Regression Uncertainty. 
                Frontiers in Probabilistic Inference: Learning Meets Sampling. ICLR 2025 Workshop.</a>
                </li>
                <li>
                <a href="https://openreview.net/forum?id=pDDODPtpx9">
                Kelen, D. M., Jung, Á., Kersch, P., & Benczur, A. A. (2025). 
                Distribution-Free Data Uncertainty for Neural Network Regression. 
                The Thirteenth International Conference on Learning Representations.</a>
                </li>
            </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};
export default N_Friedman_and_A_Benczur_distr_learning;